// header with an svg centered logo a big padding and a background image in a react class component

import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import FullLogo from "../assets/logo/full.svg"

export class Header extends React.Component {
  render() {
    return (
      <header className="relative w-full overflow-hidden">
        <div className="relative z-10 flex-col bg-primary bg-opacity-75">
          <div className="w-full flex items-center justify-center md:p-24 p-12">
            <FullLogo class="max-w-xs" />
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 160 1440 160"
            className="text-white fill-current relative top-px"
          >
            <path
              fill-opacity="1"
              d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,250.7C1248,256,1344,288,1392,304L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
        <div className="absolute z-0 top-0 left-0 w-full h-full">
          <StaticImage
            src="../assets/maastricht-background.jpg"
            alt="Maastricht"
            placeholder="blurred"
            layout="fullWidth"
            className="object-cover w-full h-full"
          />
        </div>
      </header>
    )
  }
}
